import React from "react";
import { useNavigate } from "react-router-dom";
import "./Leadership.css";

const AboutLeadership = () => {
  const navigate = useNavigate();
  return (
    <div className="AL-container">
      <div className="AL-hero">
        <div className="AL-hero-content">
          <h1 className="AL-title">Our Leadership</h1>
          <div className="AL-hero-text">
            <p>
              At iCare Village, our leadership team is responsible for setting
              the standards that guide every aspect of care we provide. With
              deep experience in healthcare, health informatics, and
              community-based support, our leaders are committed to delivering
              safe, reliable, and compassionate in-home care to older adults and
              their families.
            </p>
            <p>
              As a home care service provider, we take responsibility for the
              people who deliver care on our behalf. Our leadership oversees
              hiring, training, scheduling, and quality assurance to ensure that
              every caregiver reflects our values of respect, dignity, and
              professionalism.
            </p>
            <p>
              We believe that high-quality care starts with strong leadership
              and clear accountability. By supporting our care team and
              continuously improving our services, we aim to provide
              personalized, dependable care that allows seniors to live safely
              and confidently at home.
            </p>
            <p>
              Together, we work to strengthen the health, independence, and
              well-being of the communities we serve.
            </p>
          </div>
        </div>
      </div>

      <div className="AL-team-section">
        <h2 className="AL-section-title">Meet Our Leadership Team</h2>

        <div className="AL-founder-card">
          <div className="AL-founder-img-wrapper">
            <img
              src={require("./../images/Jonas_Pic.png")}
              alt="Dr. Jonas Bambi"
              className="AL-profile-img"
            />
          </div>
          <div className="AL-founder-info">
            <h3>Dr. Jonas Bambi</h3>
            <h4>Founder</h4>
            <p>
              Dr. Jonas Bambi is the founder of iCare Village and brings over 20
              years of experience spanning healthcare services optimization,
              health informatics, information systems, and technology
              leadership. He holds a PhD in Health Informatics and has worked
              extensively with organizations such as Island Health and Northern
              Health, supporting the design and improvement of healthcare
              delivery systems.
            </p>
            <p>
              Inspired by a deep respect for older adults and a commitment to
              helping people age with dignity, Dr. Bambi founded iCare Village
              to provide reliable, high-quality in-home care supported by
              thoughtful use of technology. His leadership focuses on ensuring
              that care services are delivered safely, ethically, and
              consistently, with clear standards for hiring, training, and
              supervision of care staff
            </p>
            <p>
              Dr. Bambi’s approach combines evidence-informed decision-making
              with compassion and community values, guiding iCare Village in its
              mission to make aging at home safer, more connected, and more
              sustainable for seniors and their families.
            </p>
          </div>
        </div>

        <div className="AL-member-grid">
          <div className="AL-member-card">
            <div className="AL-member-img-wrapper">
              <img
                src={require("./../images/Nancy_Pic.png")}
                alt="Nancy Yates"
                className="AL-profile-img"
              />
            </div>
            <div className="AL-member-info">
              <h3>Nancy Yates</h3>
              <h4>Advisor</h4>
              <p>
                Nancy Yates serves as an advisor to iCare Village, bringing
                decades of nursing experience and lived insight as a senior
                herself. A retired nurse, Nancy offers invaluable perspective on
                the real-world needs, challenges, and expectations of older
                adults receiving care at home.
              </p>
              <p>
                Her guidance helps ensure that iCare Village’s services are
                grounded in dignity, safety, and respect, and that care
                practices remain person-centred rather than task-driven. Nancy
                contributes to shaping care standards, service design, and
                quality expectations, ensuring that policies and procedures
                reflect both clinical wisdom and human understanding.
              </p>
              <p>
                Through her advisory role, Nancy helps iCare Village maintain a
                strong focus on compassionate care that honors lived experience
                and supports aging with confidence and dignity.
              </p>
            </div>
          </div>

          <div className="AL-member-card">
            <div className="AL-member-img-wrapper">
              <img
                src={require("./../images/Dang_Pic.png")}
                alt="Kha Hoang"
                className="AL-profile-img"
              />
            </div>
            <div className="AL-member-info">
              <h3>Kha Hoang</h3>
              <h4>Technical Support Lead</h4>
              <p>
                Kha Hoang leads technical support at iCare Village and is
                responsible for maintaining the reliability, security, and
                day-to-day operation of the technology systems that support care
                delivery. His work ensures that scheduling, communication, and
                service coordination tools function smoothly for both clients
                and care staff.
              </p>
              <p>
                With a strong understanding of the platform architecture and a
                commitment to continuous improvement, Kha plays a key role in
                enabling efficient operations while minimizing disruption to
                care services. His focus is on stability, responsiveness, and
                usability – so care teams can concentrate on what matters most:
                supporting clients safely and effectively.
              </p>
              <p>
                Kha’s role helps bridge technology and care delivery,
                reinforcing iCare Village’s commitment to dependable service and
                operational accountability.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="AL-cta-section">
        <div className="AL-cta-block AL-bg-career">
          <div className="AL-cta-content">
            <h2>Work With Us!</h2>
            <p>
              Ready to join our local team? Submit your resume to be considered
              for current and future opportunities.
            </p>
            <button className="AL-cta-btn" onClick={() => navigate("/careers")}>
              Go to Careers
            </button>
          </div>
        </div>
        <div className="AL-cta-block AL-bg-contact">
          <div className="AL-cta-content">
            <h2>Connect with us</h2>
            <p>
              We'd love to hear from you! Here are all the ways you can get in
              touch.
            </p>
            <button
              className="AL-cta-btn"
              onClick={() => navigate("/ContactUs")}
            >
              Go to Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutLeadership;
